'use strict';

const OffCanvas = require('./off-canvas');

const App = {
  init() {
    OffCanvas.init();
  }
};

module.exports = App;
